
import { store } from "../..";
import { delete_favorite_prompt, delete_favorite_prompt_cat, fav_prompt_category, fav_prompt_list, generate_fav_question, run_fav_prompt_sql, save_fav_prompt, update_favorite_prompt } from "../../helpers/fakebackend_helper";
import { open_error_modal } from "../Error_Modal/reducer";
import { open_success_modal } from "../Success_Modal/reducer";
import { bot_details } from "../thunks";
import { delete_fav_prompt_fail, delete_fav_prompt_success, save_fav_prompt_fail, save_fav_prompt_success, set_Fav_Prompt_Category_Fail, set_Fav_Prompt_Category_Success, set_Fav_Prompt_List_Fail, set_Fav_Prompt_List_Success, set_Fav_Prompt_Question_SQL_fail, set_Fav_Prompt_Question_SQL_success, set_fav_prompt_sql_result, start_Fav_Prompt_Loading, start_Fav_Prompt_SQL_Loading, update_favorite_prompt_fail, update_favorite_prompt_success } from "./reducer";

export const Get_Favourite_Prompt_List = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_Loading())

   const response = fav_prompt_list(filterData)

   const api_response = await response
   

   dispatch(set_Fav_Prompt_List_Success(api_response))
   
    
  } catch (error) {
    dispatch(set_Fav_Prompt_List_Fail(error))
  }
};

export const Get_Favourite_Prompt_Category = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_Loading())

  //  console.log(filterData, "category")
   const response = fav_prompt_category(filterData)

   const api_response = await response
   

   dispatch(set_Fav_Prompt_Category_Success(api_response))
   
    
  } catch (error) {
    dispatch(set_Fav_Prompt_Category_Fail(error))
  }
};


export const Generate_Fav_Prompt_Question = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_Loading())

   const response = generate_fav_question(filterData)

   const api_response = await response
   

   dispatch(set_Fav_Prompt_Question_SQL_success(api_response))
   
    
  } catch (error) {
    dispatch(set_Fav_Prompt_Question_SQL_fail(error))
  }
};


export const  Save_Fav_Prompt = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_Loading())

   const response = save_fav_prompt(filterData)

   const api_response = await response
   

   dispatch(save_fav_prompt_success(api_response))

  //  dispatch(bot_details(assistant_id))

  dispatch(Get_Favourite_Prompt_List({ Bot_ID:filterData.Bot_ID }))

   dispatch(Get_Favourite_Prompt_Category({ group_id:filterData.group_id}))

  dispatch(open_success_modal("Prompt Saved to Favourite !"))
   
    
  } catch (error) {
    dispatch(save_fav_prompt_fail(error))
  }
};



export const  Delete_Fav_Prompt = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_Loading())

   const response = delete_favorite_prompt(filterData.Bot_Favorite_Prompt_ID)

   const api_response = await response
   
   dispatch(delete_fav_prompt_success())

   dispatch(open_success_modal("Favourite Prompt Deleted Successfully"))


   dispatch(Get_Favourite_Prompt_List({ Bot_ID:filterData.Bot_ID }))

  //  dispatch(bot_details(filterData.assistant_id))
   
    
  } catch (error) {
    dispatch(delete_fav_prompt_fail())
  }
};



export const  Update_Fav_Prompt = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_Loading())

   const response = update_favorite_prompt(filterData)

   const api_response = await response
   
   dispatch(update_favorite_prompt_success())

   
   dispatch(Get_Favourite_Prompt_Category({group_id:store.getState().BotDetails.Bot_Details.Group_ID}))
   dispatch(Get_Favourite_Prompt_List({ Bot_ID:filterData.Bot_ID }))
   dispatch(open_success_modal("Favourite Prompt Updated Successfully"))

  //  dispatch(bot_details(filterData.assistant_id))
   
    
  } catch (error) {
    dispatch(update_favorite_prompt_fail())
  }
};

export const  Run_Fav_Prompt_SQL = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_SQL_Loading())

   const response = run_fav_prompt_sql(filterData)

   const api_response = await response
   
   dispatch(set_fav_prompt_sql_result(api_response))

   
    
  } catch (error) {
    dispatch(update_favorite_prompt_fail())
    dispatch(open_error_modal("Some thing went wrong while executing query please check your query"))
  }
};

export const  Delete_fav_Prompt_Category = (filterData) => async (dispatch) => {



  try {


   dispatch(start_Fav_Prompt_SQL_Loading())

   const response = delete_favorite_prompt_cat(filterData.Prompt_Category)

   const api_response = await response

   dispatch(Get_Favourite_Prompt_Category(filterData))
   
   dispatch(save_fav_prompt_success(api_response))

   
    
  } catch (error) {
    dispatch(update_favorite_prompt_fail())
  }
};









  






  

